<template>
  <div>
    <el-form :inline="false" ref="childFormRef" :model="childForm" class="company-info_form"
             :label-width="getIsMobile?'0':'120px'" :label-position="getIsMobile?'top':'right'">
      <el-form-item label="是否含税" prop="hs">
        <el-radio-group v-model="hs">
          <el-radio :label="0">含税</el-radio>
          <el-radio :label="2">未税</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-table :data="modelList" border style="width: 100%; margin-bottom: 10px">
          <el-table-column label="品牌" align="center ">
            <template v-slot="scope">
              <el-input v-model="scope.row.source" placeholder="请输入品牌" />
            </template>
          </el-table-column>
          <el-table-column label="型号" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.xhname" placeholder="请输入型号" />
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.num" placeholder="请输入数量" />
            </template>
          </el-table-column>

          <el-table-column label="单价" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.price" placeholder="请输入单价" />
            </template>
          </el-table-column>

          <el-table-column label="总价" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.zprice" placeholder="请输入总价" readonly disabled/>
            </template>
          </el-table-column>

          <el-table-column label="备注" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.bz" placeholder="请输入备注" />
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template v-slot="scope">
              <el-button type="danger" size="small" @click="handleRemove(scope.$index)" class="el-icon-delete">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-button type="primary" @click="addModel" size="small" class="el-icon-plus">增加型号</el-button>
      <el-form-item label="合同条款" class="model-editor">
        <div ref="contractEditor" class="contractEditor"></div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { defineComponent, nextTick, onMounted, reactive, ref, watch,computed } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
import E from 'wangeditor'


export default defineComponent({
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    contractContent: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { getIsMobile } = useRootSetting()
    const childForm = reactive({})
    const contractEditor = ref(null)
    const childFormRef = ref(null)
    const hs = ref(0)
    const fid = ref(0)
    const editorContent = ref('')
    const modelList = ref([
      { id:'',source: '', xhname: '', price: '', num: '', zprice: '', bz: '' }
    ])

    // 添加联系人
    const addModel = () => {
      modelList.value.push({ id:'',source: '', xhname: '', price: '', num: '', zprice: '', bz: '' })
    }

    // 删除联系人
    const handleRemove = (index) => {
      modelList.value.splice(index, 1)
    }

    // **初始化编辑器**
    const initEditor = async () => {
      if (!contractEditor.value) return
      contractEditor.value = new E(contractEditor.value)
      contractEditor.value.config.placeholder = '请输入内容...'
      contractEditor.value.config.onchange = (newHtml) => {
        editorContent.value = newHtml
      }
      contractEditor.value.create() // 创建编辑器
    }


    onMounted(async () => {
      await nextTick() // 确保 DOM 加载完成
      await initEditor() // 调用初始化函数
    })


    // 定义一个清空数据的方法
    const clearTable = () => {
      modelList.value.forEach(row => {
        Object.keys(row).forEach(key => {
          row[key] = '' // 清空每一项的值
        })
      })
    }
    watch(
      () => [contractEditor.value, props.data.row],
       ([editor, row]) => {
        if (editor && row) {
            if (editor.txt && typeof editor.txt.html === 'function') {
              editor.txt.html(row.a1 || '')  // 如果 a1 为 undefined，则传入空字符串
            }
            modelList.value = row.childdata
            fid.value = row.id
            if(row.kpzt === '已开' || row.kpzt === '未开'){
              hs.value = 0
            }else{
              hs.value = 2
            }
        }
      },
      { deep: true, immediate: true }
    )

    watch(()=>props.contractContent,(val)=>{
      if(val) {
        contractEditor.value.txt.html(val)
      }
    })

// 计算每行的总价
    watch(
      modelList,
      (newList) => {
        newList.forEach((row) => {
          const num = Number(row.num) ;
          const price = Number(row.price) ;
          row.zprice = Number((num * price)).toFixed(2); // 保留两位小数
        });
      },
      { deep: true }
    );

// 计算所有行的总金额
    const totalAmount = computed(() => {
      return modelList.value.reduce((sum, row) => sum + (Number(row.zprice) || 0), 0);
    });

    return {
      editorContent,
      fid,
      childFormRef,
      contractEditor,
      childForm,
      hs,
      modelList,
      getIsMobile,
      totalAmount,
      clearTable,
      addModel,
      handleRemove
    }
  }
})
</script>
<style scoped lang="scss">
.company-info_form {
  padding: 0 60px 20px 20px;
}

.el-icon-plus {
  margin-bottom: 20px;
  float: right;
}

.model-editor {
  margin-top: 80px;
}
.contractEditor {
  min-height: 200px;
  z-index: 1!important;
  position: relative;
}

</style>
